/**
 * Constantes de cooldown de sync de maestros extraídas a un archivo separado
 * para evitar require cycles entre `sync/core/masterSyncPolicy` y
 * `catalog/infra/catalogHydrationState`.
 */

/** Cooldown entre pulls automáticos de maestros (Realtime / focus / timer respaldo). */
export const MASTERS_SYNC_COOLDOWN_MS = 15 * 60 * 1000;

/** Intervalo del timer de respaldo (solo app visible). */
export const MASTERS_BACKUP_INTERVAL_MS = 15 * 60 * 1000;
